import { React, useState, useEffect, lazy } from 'react'
import { useParams, useLoaderData } from 'react-router-dom'
import { motion } from 'framer-motion'

import './Realisation.scss'

import { useDocumentTitle, useDocumentDescription, useDocumentConfig } from 'hooks/useDocument'

// import Loader from 'components/Loader'
import Tag from 'components/Tag'
import Card from 'components/Card'
import Button from 'components/Button'
import RefletRefletBanner from 'components/RefletRefletBanner'

//import Markdown from 'components/Markdown'
const Markdown = lazy(() => import('components/Markdown'))

const Realisation = () => {
	const data = useLoaderData()
	const projects = data.listing
	const content = data.content

	const { id } = useParams()
	const [title, setTitle] = useState(undefined)
	const [description, setDescription] = useState(undefined)
	const [projectPrev, setProjectPrev] = useState(null)
	const [projectNext, setProjectNext] = useState(null)
	const [tags, setTags] = useState([])
	const [isMuseum, setIsMuseum] = useState(false)

	useDocumentTitle(title)
	useDocumentDescription(description)
	useDocumentConfig(`white`, true)

	useEffect(() => {
		if (projects === null) {
			return
		}

		// Current
		const currentIndex = projects.findIndex(elt => elt.id === id)
		const project = projects.find(project => project.id === id)

		if (project) {
			setTags(project.tags)
			setTitle(project.title)
			setDescription(project.description)
			setIsMuseum(project.sector === 'museum')


			// Featured
			const prev = currentIndex > 0 ? currentIndex - 1 : projects.length - 1
			const next = currentIndex < projects.length - 1 ? currentIndex + 1 : 0
			setProjectPrev(projects[prev])
			setProjectNext(projects[next])
		}
	}, [projects, id])

	return (
		<motion.main
			className='realisation'
			initial={{ opacity: 0, transition: { duration: 0.3 } }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0, transition: { duration: 0.3 } }}
		>
			<picture id="project__hero">
				<source srcSet={`/realisations/${id}/hero.webp`} type='image/webp' />
				<img src={`/realisations/${id}/hero.jpg`} alt="Visuel de présentation du projet" />
			</picture>
			
			{isMuseum && <RefletRefletBanner />}
			
			<div className='realisation_container'>
				<ul
					id='project__taglist'
					className='no-prefix'
				>
					{tags.map((tag, i) => {
						return (
							<li key={i}>
								<Tag type={tag.type}>{tag.content}</Tag>
							</li>
						)
					})}
				</ul>
				
				<Markdown>
					{ content }
				</Markdown>

				<section id='project__more'>
					<div className='project__more_item'>
						<div className='project__more_presentation'>
							<h3>Ces réalisations peuvent également vous intéresser</h3>
							<Button
								to={`${process.env.PUBLIC_URL}/realisations-sur-mesure`}
								version='1'
							>
								Toutes nos réalisations
							</Button>
						</div>
					</div>
					{projectPrev !== null && (
						<div className='project__more_item'>
							<Card
								id={projectPrev.id}
								type='realisation'
								thumbnail={`/realisations/${projectPrev.id}/thumbnail.jpg`}
								title={projectPrev.title}
								description={projectPrev.description}
								tags={projectPrev.tags}
							/>
						</div>
					)}

					{projectNext !== null && (
						<div className='project__more_item'>
							<Card
								id={projectNext.id}
								type='realisation'
								thumbnail={`/realisations/${projectNext.id}/thumbnail.jpg`}
								title={projectNext.title}
								description={projectNext.description}
								tags={projectNext.tags}
							/>
						</div>
					)}
				</section>
			</div>
		</motion.main>
	)
}

export default Realisation
